import Cookies from 'js-cookie';
import {SF_REFERENCE_ID, EPN_REFERENCE_ID, PROSPECT_ID} from '@/services/api/api-constants';

export function getProspectId() {
  try {
    const prospectIdObj = JSON.parse(sessionStorage.getItem(PROSPECT_ID));
    return prospectIdObj?.value ?? '';
  } catch {
    // Ignore JSON parse errors
    return '';
  }
}

export function getSfReferenceId() {
  return Cookies.get(SF_REFERENCE_ID) || Cookies.get(EPN_REFERENCE_ID) || '';
}

export function getTrackingMetadata() {
  return {
    customerProspectId: getProspectId(),
    sfReferenceId: getSfReferenceId(),
  };
}
